module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteLink":"delete","errors":{"tweetNotFound":"A tweet could not be loaded."}},"de":{"deleteLink":"löschen","errors":{"tweetNotFound":"😵 Ein Tweet existiert nicht (mehr)."}}}')
  delete Component.options._Ctor
}
